import {observable, computed, action} from 'mobx';
import {LOCALSTORAGE_BRAND_ID_KEY} from "../constants";

export default class OrderStore {

    @observable mainShopData = { eta: 0, hide_eta: false, image:'', name:'', shop_hours: 'Mon 9:30am-3:00pm, Tues-Thurs 9:30am-8:30pm, Fri-Sat 9:30am-9pm, Sun 11:00am-4:00pm' };
    @observable primaryQueue = [];
    @observable columnCount = 6;
    @observable rowCount = 10;

    @action updateColCount(newColCount) {
        if(typeof newColCount !== 'undefined' &&
            newColCount !== this.columnCount) {
            this.columnCount = newColCount;
        }
    }

    @action updateRowCount(newRowCount) {
        if(typeof newRowCount !== 'undefined' &&
            newRowCount !== this.rowCount) {
            this.rowCount = newRowCount;
        }
    }

    @computed get boxedOrderFontSize(){
        if (10 <= this.columnCount || 12 <= this.rowCount){
            return '3.9em';
        } else if (7 <= this.columnCount || 10 <= this.rowCount){
            return '4.3em';
        } else if(5 <= this.columnCount || 8 <= this.rowCount) {
            return '5.1em';
        } else {
            return '6.8em';
        }
    }

    @computed get boxedOrderNameFontSize(){
        if (10 <= this.columnCount || 12 <= this.rowCount){
            return '2.5em';
        } else if (7 <= this.columnCount || 10 <= this.rowCount){
            return '3.1em';
        } else if(5 <= this.columnCount || 8 <= this.rowCount) {
            return '3.7em';
        } else {
            return '5.4em';
        }
    }

      @computed get boxedOrderCheckInFontSize(){
        if (10 <= this.columnCount || 12 <= this.rowCount){
            return '1.9em';
        } else if (7 <= this.columnCount || 10 <= this.rowCount){
            return '2.3em';
        } else if(5 <= this.columnCount || 8 <= this.rowCount) {
            return '3.5em';
        } else {
            return '5.4em';
        }
    }

    @computed get grabSubArrays() {
        let splitQueue = [];
        for(let i=0; i < this.columnCount; i++) {
            splitQueue.push(this.sortedQueue.slice((i * this.rowCount), ((i + 1) * this.rowCount)));
        }
        return splitQueue;
    }

    @action updateMainShopData(name, image, eta, wh, brand, hide_eta, id){
        this.mainShopData.eta = eta;
        this.mainShopData.hide_eta = hide_eta
        this.mainShopData.brand = brand;
        // Save brand id to local storage so it can show an accurate logo in future loading screens
        if (brand) {
            localStorage.setItem(LOCALSTORAGE_BRAND_ID_KEY, brand.id)
        }

        this.mainShopData.image = image;
        this.mainShopData.name = name;
        if(typeof wh ==='string' && wh !== this.mainShopData.shop_hours) {
            this.mainShopData.shop_hours = wh;
        }
        this.mainShopData.id = id
    }

    @computed get mainShopEta() {
        if(typeof this.mainShopData.eta === 'number' &&  !isNaN(this.mainShopData.eta)) {
            return this.mainShopData.eta
        } else {
            return '?'
        }
    }

    @computed get getCurrShopTimeBlocksArray() {
        let separators = [';', ','];
        let shop_hours = this.mainShopData.shop_hours;
        let shop_hours_array = shop_hours.split(new RegExp(separators.join('|'), 'g'));
        let previous = '';
        let shop_hours_array_mapped = [];
        shop_hours_array.forEach(function( hour_block ) {
            let hour_blocked_trimmed = hour_block.trim();
            if (hour_blocked_trimmed.length < 5) {
                previous += hour_blocked_trimmed + ', ';
            } else {
                shop_hours_array_mapped.push((previous + hour_blocked_trimmed));
                previous = '';
            }
        });
        return shop_hours_array_mapped;
    }

    @computed get ordersDict() {
        let ordersDictObj = {};
        this.primaryQueue.forEach((order)=>{
            ordersDictObj[order.id] = order;
        });
        return ordersDictObj;
    }

    @computed get sortedQueue() {
        return this.primaryQueue.sort((order1, order2)=>{
            return order1.id - order2.id;
        })
    }

    @action updateQueue(orders) {
        let incomingOrdersDict = {};
        let oldOrdersDict = this.ordersDict;
        orders.forEach((order)=>{
            incomingOrdersDict[order.id] = order;
            if(oldOrdersDict[order.id]) {
                if((oldOrdersDict[order.id].status !== order.status)
                  || (oldOrdersDict[order.id].display_value !== order.display_value)
                  || (oldOrdersDict[order.id].pendingCheckin !== order.pendingCheckin)
                  || (oldOrdersDict[order.id].pendingRefund !== order.pendingRefund)) {
                    this.updateOrder(order)
                }
            } else {
                this.addOrder(order);
            }
        });
        this.removeExpiredOrders(incomingOrdersDict);
    }

    @action removeExpiredOrders(incomingOrdersDict) {
        this.primaryQueue.forEach((order, index)=>{
            if(!incomingOrdersDict[order.id]) {
                this.removeOrder(index);
            }
        })
    }

    @action updateOrder(order) {
        this.ordersDict[order.id].status = order.status;
        this.ordersDict[order.id].display_value = order.display_value;
        this.primaryQueue.forEach(pQOrder=> {
            if (pQOrder.id === order.id) {
                pQOrder.status = order.status;
                pQOrder.display_value = order.display_value;
                pQOrder.pendingCheckin = order.pendingCheckin;
                pQOrder.pendingRefund = order.pendingRefund;

            }
        })
    }

    @action removeOrder(pQIndex) {
        this.primaryQueue.splice(pQIndex, 1);
    }

    @action addOrder(order) {
        this.primaryQueue.unshift(order);
    }
}



// WEBPACK FOOTER //
// ./src/stores/OrderStore.js